import { WHOAMI_REQUEST, WHOAMI_SUCCESS, WHOAMI_FAILURE } from './auth';
import { SIGN_REQUEST, SIGN_SUCCESS, SIGN_FAILURE } from "./sign";
import { DOCUMENT_VIEW_REQUEST, DOCUMENT_VIEW_SUCCESS, DOCUMENT_VIEW_FAILURE } from './view';

export function whoami(token) {
  return (dispatch) => {
    dispatch({ type: WHOAMI_REQUEST });
    return fetch(`/api/ite/whoami?token=${token}`)
      .then(async (response) => {
        const data = await response.json();
        if (data.status === 'success') {
          dispatch({
            type: WHOAMI_SUCCESS,
            payload: data.result,
          });
        } else {
          dispatch({
            type: WHOAMI_FAILURE,
            payload: data,
          });
        }
      });
  };
}

export const DOCS_UPDATE = 'Ite.Docs.Update';
export const DOCS_REQUEST = 'Ite.Docs.Request';
export const DOCS_SUCCESS = 'Ite.Docs.Success';
export const DOCS_FAILURE = 'Ite.Docs.Failure';

export function fetchDocs(token: string) {
  return (dispatch) => {
    dispatch({ type: DOCS_REQUEST });
    return fetch(`/api/ite/documents?token=${token}`)
      .then(async (response) => {
        const data = await response.json();
        if (data.status === 'success') {
          dispatch({
            type: DOCS_SUCCESS,
            payload: data.result,
          });
        } else {
          dispatch({
            type: DOCS_FAILURE,
            payload: data,
          });
        }
      });
  };
}

export function fetchDocument(id: number, token: string) {
  return (dispatch) => {
    dispatch({ type: DOCUMENT_VIEW_REQUEST });
    return fetch(`/api/ite/documents/${id}?token=${token}`)
      .then(async (response) => {
        const data = await response.json();
        if (data.status === 'success') {
          dispatch({
            type: DOCUMENT_VIEW_SUCCESS,
            payload: data.result,
          });
        } else {
          dispatch({
            type: DOCUMENT_VIEW_FAILURE,
            payload: data,
          });
        }
      });
  };
}

export const DOCS_SELECT = 'Ite.Docs.Select';

export function selectDocs(docs, checked) {
  return {
    type: DOCS_SELECT,
    payload: docs?.reduce((memo, el) => {
      memo[el] = checked;
      return memo;
    }, {})
  };
}

export function signDocs(docs: Array<string>, key: Key, token: string, sync = true) {
  return (dispatch) => {
    dispatch({ type: SIGN_REQUEST });
    return fetch(`/api/ite/sign?token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ docs, key, async: !sync })
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === 'success') {
        if (!sync) {
          data.result = {
            list: docs.map((id) => {
              return { id, error: { code: 115 }};
            }),
          };
        }
        dispatch({
          type: SIGN_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({
          type: SIGN_FAILURE,
          payload: data,
        });
      }
    });
  }
}

export function inprogressDocs(token: string) {
    return (dispatch, getState) => {
      let inprogress = false;
      setInterval(() => {
        if (!token || inprogress) {
          return false;
        }
        inprogress = true;

        const { ite } = getState();
        ite.docs.list.filter((el) => el.error?.code === 115).reduce((promise, el) => {
          return promise.then(() => fetch(`/api/ite/documents/${el.id}?token=${token}`).then(async (response) => {
            const data = await response.json();
            if (data.status === "success" && data.result.error?.code !== 115) {
              dispatch({
                type: DOCS_UPDATE,
                payload: { [el.id]: data.result },
              });
            }
          }));
        }, Promise.resolve()).then(() => {
          const { view } = getState();
          if (view.error?.code === 115) {
            return fetch(`/api/ite/documents/${view.id}?token=${token}`).then(async (response) => {
              const data = await response.json();
              if (data.status === "success" && data.result.error?.code !== 115) {
                dispatch({
                  type: DOCUMENT_VIEW_SUCCESS,
                  payload: data.result,
                });
              }
            });
          }
        }).finally(() => {
          inprogress = false;
        });
      }, 1500);
    };
  }
  
